import React from "react";
import Card from "react-bootstrap/Card";
//import { ImPointRight } from "react-icons/im";
import { BsCodeSlash } from "react-icons/bs";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I’m <span className="purple">Abhinav Rathee</span>, a Computer Science Engineering Student at
            <span className="purple"> Chitkara University</span>, based in <span className="purple">Haryana, India</span>.
            <br />
            I’m currently focused on strengthening my <span className="purple">software development skills</span> through structured learning and hands-on project work.
            <br />
            <br />
            What I’m Working On:
          </p>
          <ul>
            <li className="about-activity">
              <span className="purple"><BsCodeSlash /></span>&nbsp; Developing full-stack web and mobile skills
            </li>
            <li className="about-activity">
              <span className="purple"><BsCodeSlash /></span>&nbsp; Building scalable, real-world projects
            </li>
            <li className="about-activity">
              <span className="purple"><BsCodeSlash /></span>&nbsp; Applying core computer science fundamentals
            </li>
          </ul>
          <p style={{ color: "rgb(155 126 172)", fontWeight: 500 }}>
            "Always learning, always building."
          </p>
          <footer className="blockquote-footer">Abhinav</footer>
        </blockquote>
      </Card.Body>
    </Card >
  );
}

export default AboutCard;
